@if (albumLoaded) {
  <div class="tea-album-detail">
    <div class="album-info">
      <div class="album-title align-center">
        <img [src]="albumIconUrl" />
        <p>{{ album.title }}</p>
      </div>
      <div class="album-creator align-top">
        <img src="{{ album.student.avatar }}" />
        <div class="user-info">
          <a class="spen-util-link" [routerLink]="['/students/teacher/', album.student.id]">{{ album.student.name }}</a>
          <p class="class-name">{{ album.student.class_name }}{{ album.student.attendance_number }}番</p>
        </div>
      </div>
      <span>作成日時：{{ album.created_at }}</span>
      @if (album.updated_at !== '-') {
        <span>更新日時：{{ album.updated_at }}</span>
      }
      <p>種別：{{ teacherCreator ? '先生配信' : '自主作成' }}</p>
      @if (teacherCreator) {
        <p>
          配信アルバム名：<a class="spen-util-link" [routerLink]="['/albums/teacher/delivery/', album.id]">{{ album.title }}</a>
        </p>
      }
      @if (layoutService.isTabletDownView.value) {
        <p>活動記録数：{{ album.activity_records_count | number }}</p>
      }
    </div>
    <div class="word-cloud-link" (click)="switchToShowWordCloud()">
      <a class="spen-util-link">概況を見る</a>
    </div>
    @if (firstActivityRecordsLoaded) {
      @if (!checkEmptyAlbum) {
        <div
          class="content"
          [ngClass]="{ 'content-bottom-loading': moreActivityRecordsLoading }"
          infinite-scroll
          infiniteScrollDistance="1"
          infiniteScrollThrottle="300"
          [scrollWindow]="true"
          [infiniteScrollDisabled]="!metaData.next_id"
          (scrolled)="getAlbumActivityRecords(metaData)"
        >
          @if (!layoutService.isTabletDownView.value) {
            <div
              class="act-thumbnail"
              #actThumbnail
              [ngClass]="{ 'sticky-top': stickyTop, 'sticky-bottom': stickyBottom }"
              infinite-scroll
              infiniteScrollDistance="1"
              infiniteScrollThrottle="300"
              [scrollWindow]="false"
              [infiniteScrollDisabled]="!metaData.next_id"
              (scrolled)="getAlbumActivityRecords(metaData)"
            >
              @if (lastestActivityRecord) {
                <div class="latest-act-item-thumbnail">
                  <p class="title">最新の活動記録</p>
                  <div class="thumb current-activity-record" data-id="item-1" (click)="goToDetail($event)">
                    <p class="truncate-text">{{ lastestActivityRecord.title }}</p>
                    <div class="act-content-thumb">
                      <div
                        class="truncate-paragraph"
                        [ngClass]="[getThumbnailAnswerImage(lastestActivityRecord) ? 'line-clamp-3' : 'line-clamp-9']"
                      >
                        {{ getThumbnailText(lastestActivityRecord) }}
                      </div>
                      @if (srcThumbnailImage) {
                        <div class="img-container">
                          <img src="{{ srcThumbnailImage }}" />
                        </div>
                      }
                    </div>
                    <p class="page">{{ album.activity_records_count | number }}</p>
                  </div>
                </div>
              }
              @if (album.goal || album.outline) {
                <div class="goal-outline-thumbnail">
                  <p class="title" [class.goal-position]="!lastestActivityRecord">目標・概要</p>
                  <div class="thumb" data-id="item-2" (click)="goToDetail($event)" [class.current-activity-record]="!lastestActivityRecord">
                    <div class="act-content-thumb">
                      @if (album.goal) {
                        <div>
                          <p>目標：</p>
                          <p class="goal truncate-paragraph" [ngClass]="[album.outline ? 'line-clamp-3' : 'line-clamp-8']">
                            {{ album.goal }}
                          </p>
                        </div>
                      }
                      @if (album.outline) {
                        <div>
                          <p>概要：</p>
                          <p class="goal truncate-paragraph" [ngClass]="[album.goal ? 'line-clamp-3' : 'line-clamp-8']">
                            {{ album.outline }}
                          </p>
                        </div>
                      }
                    </div>
                    <p class="page">0</p>
                  </div>
                </div>
              }
              @for (activityRecord of activityRecords; track activityRecord.id; let i = $index) {
                <div>
                  @if (setCassetteTitle(activityRecords[i - 1], activityRecords[i])) {
                    <p class="title">{{ cassetteTitle }}</p>
                  }
                  <div class="thumb" [attr.data-id]="['item-' + (i + 3)]" (click)="goToDetail($event)">
                    <p class="truncate-text">{{ activityRecord.title }}</p>
                    <div class="act-content-thumb">
                      <div
                        class="truncate-paragraph"
                        [ngClass]="[getThumbnailAnswerImage(activityRecord) ? 'line-clamp-3' : 'line-clamp-9']"
                      >
                        {{ getThumbnailText(activityRecord) }}
                      </div>
                      @if (srcThumbnailImage) {
                        <div class="img-container">
                          <img src="{{ srcThumbnailImage }}" />
                        </div>
                      }
                    </div>
                    <p class="page">{{ i + 1 }}</p>
                  </div>
                </div>
              }
              @if (moreActivityRecordsLoading) {
                <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
              }
            </div>
          }
          <div class="activity-records" #actDetail [class.activity-detail-position]="onScroll && !layoutService.isTabletDownView.value">
            @if (lastestActivityRecord) {
              <div class="cassette">
                <p class="cassette-title">最新の活動記録</p>
                <div class="act-detail" id="item-1">
                  <app-activity-view-detail
                    [activityRecord]="album.latest_activity_record"
                    [page]="album.activity_records_count"
                    [totalPage]="album.activity_records_count"
                  >
                  </app-activity-view-detail>
                </div>
              </div>
            }
            @if (album.goal || album.outline) {
              <div class="cassette">
                <p class="cassette-title">目標・概要</p>
                @if (!layoutService.isTabletDownView.value) {
                  <p class="serial">[ 0/{{ album.activity_records_count | number }} ]</p>
                }
                <div class="act-detail" id="item-2">
                  @if (album.goal) {
                    <div class="goal-outline-detail">
                      <p>目標：</p>
                      <div class="act-content">
                        <app-read-more [content]="album.goal" [collapsedLength]="499"></app-read-more>
                      </div>
                    </div>
                  }
                  @if (album.outline) {
                    <div class="goal-outline-detail">
                      <p>概要：</p>
                      <div class="act-content">
                        <app-read-more [content]="album.outline" [collapsedLength]="499"></app-read-more>
                      </div>
                    </div>
                  }
                  <div class="page">- 0 -</div>
                </div>
              </div>
            }
            @for (activityRecord of activityRecords; track activityRecord.id; let i = $index) {
              <div class="cassette">
                @if (setCassetteTitle(activityRecords[i - 1], activityRecords[i])) {
                  <p class="cassette-title">{{ cassetteTitle }}</p>
                }
                <div class="act-detail" [attr.id]="['item-' + (i + 3)]">
                  <app-activity-view-detail [activityRecord]="activityRecord" [page]="i + 1" [totalPage]="album.activity_records_count">
                  </app-activity-view-detail>
                </div>
              </div>
            }
            @if (moreActivityRecordsLoading) {
              <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
            }
          </div>
        </div>
        @if (!lastestActivityRecord) {
          <p class="empty-activity-record">ここに追加された活動記録が表⽰されます。</p>
        }
      } @else {
        <p class="empty-activity-record">ここに追加された活動記録が表⽰されます。</p>
      }
    } @else {
      <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
    }
  </div>
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}

@if (isShowingModal) {
  <div>
    @if (gotWordCloudResponse === 'not yet') {
      <app-word-cloud-wait-modal (closeFilter)="onCloseWordCloud()"> </app-word-cloud-wait-modal>
    }
    @if (gotWordCloudResponse === 'have gotten') {
      <div>
        @if (gotWordCloudDocumentId === 'success') {
          <app-word-cloud-modal (closeFilter)="onCloseWordCloud()"> </app-word-cloud-modal>
        }
        @if (gotWordCloudDocumentId === 'failed') {
          <app-word-cloud-error-modal (closeFilter)="onCloseWordCloud()"> </app-word-cloud-error-modal>
        }
      </div>
    }
  </div>
}
